export default __webpack_public_path__ + "static/cubo-colsubsidio-c1a398b5e3f448c4bcc0dd8d2e2f08cd.jpg";